// ============================================================
// Primitives 10, 11, 12 — EmptyState, Skeleton, ErrorState.
// ------------------------------------------------------------
// Ces trois-là portent une règle du projet à elles seules :
// un état vide HONNÊTE et un état d'erreur HONNÊTE. Jamais de jeu
// de démonstration en repli d'une erreur réseau — c'est ce que
// faisait AGC, où l'écran affichait des données inventées quand
// l'API ne répondait pas, si bien que personne ne voyait la panne.
// ============================================================

import Button from './Button.jsx';

export function EmptyState({ title, children, action }) {
  return (
    <div className="empty">
      <p className="empty__title">{title}</p>
      {children ? <p className="empty__text">{children}</p> : null}
      {action}
    </div>
  );
}

export function Skeleton({ height = 'var(--row-h)', width = '100%' }) {
  // Seule exception tolérée au « zéro style en ligne » : ce sont des
  // dimensions passées en paramètre, pas des couleurs. Et ce fichier
  // est dans ui/, pas dans features/.
  return <div className="skeleton" style={{ height, width }} aria-hidden="true" />;
}

export function SkeletonRows({ rows = 4 }) {
  return (
    <div className="stack stack--tight" aria-busy="true" aria-live="polite">
      <span className="sr-only">Chargement en cours</span>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} />
      ))}
    </div>
  );
}

export function ErrorState({ error, onRetry, title = 'Impossible de charger' }) {
  const isNetwork = error?.code === 'network' || error?.code === 'timeout';
  return (
    <div className="error-state" role="alert">
      <p className="error-state__title">{isNetwork ? 'Serveur injoignable' : title}</p>
      <p className="error-state__text">
        {error?.message ?? 'Une erreur est survenue.'}
      </p>
      {/* L'identifiant d'incident permet de retrouver la ligne exacte
          dans `journalctl -u mertens-api`. C'est ce qui remplace le
          message d'erreur technique qu'on ne renvoie jamais au client. */}
      {error?.incidentId ? (
        <p className="error-state__incident">Incident {error.incidentId}</p>
      ) : null}
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry}>
          Réessayer
        </Button>
      ) : null}
    </div>
  );
}

export default EmptyState;
